<script setup>
import { reactive} from 'vue';
import {accessControlApi, stripe_API} from "@/api/forwriting_index";

const point_limit = reactive({
  is_over: false
})

const check = async () => {
  point_limit.is_over = (await accessControlApi.is_over_point_limit()).data
  return point_limit.is_over
}

defineExpose({
  check,
})

const register_standard_plan = async( ) => {
  point_limit.is_over = false
  console.log("register_standard_plan()...")

  // const tenant_id = data.tenant_id
  // console.log("tenant_id:", tenant_id)

  const resp = await stripe_API.get_checkout_url()
  const url = resp.data
  console.log("url:", url)
  window.location.href = url.toString()
}

</script>

<template>

  <!-- modal_over_points -->
  <div v-if="point_limit.is_over" class="modal_over_points">
    <div class="modal-content">
      <div class="row" style="margin-top: 10px;text-align: center;height: 40px">
        <p>
          {{$t( "CheckOverPoints.try_is_over")}}

          <!-- todo: 轉向到升級 plan 畫面 -->
          <button class="btn btn-primary" style="width: 280px"
                  @click="register_standard_plan">
            {{$t( "CheckOverPoints.register_standard_plan")}}</button>
        </p>
      </div>
    </div>
  </div>
  <!-- end of modal_over_points -->

</template>

<style scoped>

  .modal_over_points {
    width: 900px;
    border-radius: 6px;
    border: 1px solid rgb(238,126,92)
  }

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    max-width: 1600px;  /* お好みに合わせて変更 */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
</style>
